<template>
  <span>
    <v-tooltip right>
        <span slot="activator">
            <font-awesome-icon :icon="['fas', 'lock']" />
        </span>
        <span>{{ content }}</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    content: {
        type: String,
        default: "Only the Observer and Project Manager(s) can view this response!",
    },
  },
};
</script>

<style scoped></style>
